import { render, staticRenderFns } from "./PlantInfo.vue?vue&type=template&id=5c38b718&"
import script from "./PlantInfo.vue?vue&type=script&lang=js&"
export * from "./PlantInfo.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/PlantInfo.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports